import React from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/core/styles";
import TextInput from "components/TextInput";
import INPUT_TYPE from "../../../../../../../../../constants/INPUT_TYPE";

const useStyle = makeStyles(theme => ({
    root: {
        width: 300
    }
}))


function OfferNumberInput(
    {
        id,
        formikProps,
        disabled
    }) {

    const classes = useStyle();

    return (
        <TextInput
            className={classes.root}
            id={id + ".value"}
            label={Tr('enter_value_number')}
            formikProps={formikProps}
            type={INPUT_TYPE.NUMBER_19_WITH_NEGATIVE}
            disabled={disabled}
        />
    )


}

OfferNumberInput.propTypes = {
    id: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired
}

export default OfferNumberInput;